export default __webpack_public_path__ + "static/media/hsdh.a02b0764.png";